module.exports = __webpack_public_path__ + "img/ring_y_skip_1_null.5a1c630f.png";